export class StudyProgram {

    constructor(
        public name: string,
        public id?: number
    ){}
}
